import React from 'react';
import PropTypes from 'prop-types';
import { HorizontalFlex } from 'smartsuite-ui/lib/containers/HorizontalFlex';
import { PadContainer } from 'smartsuite-ui/lib/containers/PadContainer';
import { ButtonWithIcon } from 'smartsuite-ui/lib/forms/ButtonWithIcon';
import { icons } from 'smartsuite-ui/lib/constants/icons';
import {
    createDraggableWidget,
    getDashboardViewKey,
    onWidgetDrag,
} from './customDashboardUtils';
import WidgetInfo from './WidgetInfo';

export default function DraggableWidgetItem(props) {
    const dashboardViewKey = getDashboardViewKey(
        props.widget.dashboardKey,
        props.widget.viewKey
    );

    const hasErrorMessage =
        props.incorrectlyConfiguredDashboards[dashboardViewKey];

    const widgetClassName = hasErrorMessage
        ? 'widget-library__widget widget-library__widget--disabled'
        : 'widget-library__widget';

    function handleAdd(widget) {
        const maxY = Math.max(
            ...props.gridLayout.map((x) => Number(x.y) + Number(x.h)),
            0
        );
        const newWidget = createDraggableWidget(widget, 0, maxY);

        props.onAdd(newWidget);
    }

    return (
        <div
            className={widgetClassName}
            draggable={true}
            unselectable="on" // eslint-disable-line react/no-unknown-property
            onDragStart={(event) =>
                onWidgetDrag(event, props.widget, props.setDraggingWidget)
            }
        >
            <HorizontalFlex cssClassModifiers={['space-between', 'is-full']}>
                <PadContainer cssClassModifiers={['pad-medium']}>
                    <WidgetInfo widget={props.widget} />
                </PadContainer>
                <ButtonWithIcon
                    iconClass={icons.plus}
                    onClick={() => handleAdd(props.widget)}
                    disabled={hasErrorMessage}
                />
            </HorizontalFlex>
        </div>
    );
}

DraggableWidgetItem.propTypes = {
    gridLayout: PropTypes.instanceOf(Array).isRequired,
    incorrectlyConfiguredDashboards: PropTypes.instanceOf(Object),
    onAdd: PropTypes.func.isRequired,
    setDraggingWidget: PropTypes.func.isRequired,
    widget: PropTypes.instanceOf(Object).isRequired,
};

DraggableWidgetItem.defaultProps = {
    incorrectlyConfiguredDashboards: {},
};
